module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-search",
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "search-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    ref: "search_input",
    staticClass: "search-wrapper__search",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('repitition.search_for') + ' ' + _vm.$t('repitition.skole')
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        $event.preventDefault();
        return _vm.focusOption(0)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.chooseFirst.apply(null, arguments)
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "list-search__body"
  }, [_c('ul', _vm._l((_vm.searchList), function(option, index) {
    return _c('li', [_c('a', {
      staticClass: "js-list-search-option",
      attrs: {
        "href": option.url,
        "data-no-turbolink": "true"
      },
      on: {
        "click": function($event) {
          return _vm.chooseItem(option)
        },
        "keydown": [function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
          $event.preventDefault();
          return _vm.focusOption(index + 1)
        }, function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
          $event.preventDefault();
          return _vm.focusOption(index - 1)
        }, function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "home", undefined, $event.key, undefined)) { return null; }
          $event.preventDefault();
          return _vm.focusOption(0)
        }, function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "end", undefined, $event.key, undefined)) { return null; }
          $event.preventDefault();
          return _vm.focusOption(_vm.searchList.length - 1)
        }]
      }
    }, [_vm._v(_vm._s(option.name))])])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1d4d323a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ListWithSearch.vue
// module id = 1790
// module chunks = 1